(() => {
  const widgetSelectors = ['#reveni-bracketing-widget', '#reveni-sizing-widget']
  const styleSelector = 'style[data-reveni-widget-overrides]'

  const applyOverrides = () => {
    const sourceStyle = document.querySelector(styleSelector)
    if (!sourceStyle) return

    const css = sourceStyle.textContent

    widgetSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((container) => {
        const nodes = [container, ...container.querySelectorAll('*')]

        nodes.forEach((node) => {
          if (!node.shadowRoot) return

          let shadowStyle = node.shadowRoot.querySelector(styleSelector)

          if (!shadowStyle) {
            shadowStyle = document.createElement('style')
            shadowStyle.setAttribute('data-reveni-widget-overrides', '')
            node.shadowRoot.appendChild(shadowStyle)
          }

          if (shadowStyle.textContent !== css) {
            shadowStyle.textContent = css
          }
        })
      })
    })
  }

  const start = () => {
    applyOverrides()

    const observer = new MutationObserver(applyOverrides)
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
    return
  }

  start()
})()
